import { render, staticRenderFns } from "./TracingPickUpInfo.vue?vue&type=template&id=cef96b5c&scoped=true"
import script from "./TracingPickUpInfo.vue?vue&type=script&lang=js"
export * from "./TracingPickUpInfo.vue?vue&type=script&lang=js"
import style0 from "./TracingPickUpInfo.vue?vue&type=style&index=0&id=cef96b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef96b5c",
  null
  
)

export default component.exports